import { render } from "./ServerSelection.vue?vue&type=template&id=6a969caa&scoped=true&ts=true"
import script from "./ServerSelection.vue?vue&type=script&lang=ts"
export * from "./ServerSelection.vue?vue&type=script&lang=ts"

import "./ServerSelection.vue?vue&type=style&index=0&id=6a969caa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a969caa"]])

export default __exports__